<script setup lang="ts">
import { ref } from "vue";
import ToolTip from "../../ToolTip.vue";
import { locale } from "../../../locale";
import { selfHandUpState, selfHandUpToggle } from "../../../states/handUpState";
const btn = ref<HTMLElement | null>(null);
const click = () => {
  selfHandUpToggle()
};
</script>
<template>
  <button
    ref="btn"
    class="handup-button"
    @click="click"
    :class="{
      active: selfHandUpState,
    }"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6668 8.79891L16.65 12.4888C16.65 12.4888 16.672 6.46292 16.6757 4.76833C16.6764 3.9817 16.0376 3.34285 15.2509 3.34353C14.4636 3.34353 13.8261 3.98103 13.8261 4.76833C13.8236 6.43653 13.8127 12.4888 13.8127 12.4888L13.8282 3.42481C13.8288 2.63818 13.19 1.99933 12.4034 2C11.616 2 10.9785 2.6375 10.9785 3.42481C10.9767 5.45952 10.9671 12.4886 10.9671 12.4886L10.9785 6.11162C10.9792 5.32499 10.3404 4.68614 9.55374 4.68681C8.76643 4.68681 8.12892 5.32432 8.12892 6.11162L8.10877 14.9841L6.04358 12.9195C5.30128 12.1772 4.09883 12.1772 3.35653 12.9195C2.61423 13.6617 2.61423 14.8642 3.35653 15.6065C5.60198 17.8519 8.51914 22 13.0681 22C17.6171 22 19.4994 18.7261 19.5003 15.6426L19.5171 8.79958C19.5171 8.01228 18.8796 7.37477 18.0923 7.37477C17.305 7.37477 16.6662 8.01228 16.6668 8.79891Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>

    <ToolTip :placement="'top'" :reference="btn">{{
      selfHandUpState ? locale.tooltips.handdown : locale.tooltips.handup
    }}</ToolTip>
  </button>
</template>
<style scoped>
.handup-button {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: var(--bottom-btn-off-bg-regular);
  color: var(--bottom-btn-off-content-regular);
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  cursor: pointer;
  color: white;
}

.handup-button.error {
  cursor: default;
}

.handup-button:hover:not(.error) {
  background-color: var(--bottom-btn-off-bg-hover);
  color: var(--bottom-btn-off-content-hover);
}

.handup-button:active:not(.error) {
  background-color: var(--bottom-btn-off-bg-active);
  color: var(--bottom-btn-off-content-active);
}

.handup-button:focus:not(.error) {
  outline: none;
}

.handup-button.active:hover:not(.error) {
  background-color: var(--bottom-btn-on-bg-hover);
  color: var(--bottom-btn-on-content-hover);
}

.handup-button.active:active:not(.error) {
  background-color: var(--bottom-btn-on-bg-active);
  color: var(--bottom-btn-on-content-active);
}

.handup-button.active:not(.error) {
  background-color: var(--bottom-btn-on-bg-regular);
  color: var(--bottom-btn-on-content-regular);
}
</style>
